/* eslint-disable indent */
import styled from 'styled-components';

const Overlay = styled.div`
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: ${({ zIndex }) => zIndex};
    background-color: var(--theme-attachment-grid-bg);
    ${({ hidden }) => hidden ? 'visibility: hidden;' : ''}
    
    h2,
    button svg,
    button i, 
    button.btn-close .inx-io-icon { /* overwrite fullscreen component style */
        color: var(--theme-attachment-grid-text);
    }
    
    button:hover i,
    button:hover svg {
        color: var(--attachments-text-active);
    }
`;

export default Overlay;
